import { ContentType } from '@insided/shared/utils/contentType'
import Vote, { VoteProps } from './Vote'
import Like, { LikeProps } from './Like'
import Quote, { QuoteProps } from './Quote'
import { OpenEscalationOptions } from '../Escalation'
import SubscribeTopic, { SubscribeTopicProps } from './SubscribeTopic'
import { Author } from '../interfaces'
import { ConfigContext } from '../utils'

export interface OpeningPostContentActionsProps extends VoteProps, LikeProps, QuoteProps, SubscribeTopicProps {
  author: Author
  content: string | null
  topicId: number
  contentType: ContentType
  trashed: boolean
  isProductboardNoteCreationEnabled: boolean
  isSalesforceCaseEscalationEnabled: boolean
  isZendeskTicketEscalationEnabled: boolean
  isFreshdeskTicketEscalationEnabled: boolean
  isIntercomCreateConversationEnabled: boolean
}

const OpeningPostContentActions = (props: OpeningPostContentActionsProps) => {
  const {
    author,
    content,
    topicId,
    publicId,
    contentType,
    userId,
    trashed,
    votedBy,
    likedBy,
    votes,
    likes,
    isProductboardNoteCreationEnabled,
    isSalesforceCaseEscalationEnabled,
    isZendeskTicketEscalationEnabled,
    isFreshdeskTicketEscalationEnabled,
    isIntercomCreateConversationEnabled,
    onChangeVote,
    onChangeLike,
    onShowAlert
  } = props
  return (
    <ConfigContext.Consumer>
      {({ contentTypeConfig, moderationConfig }) => {
        return (
          <footer className='post--options-list'>
            <OpenEscalationOptions
              isProductboardNoteCreationEnabled={isProductboardNoteCreationEnabled}
              isSalesforceCaseEscalationEnabled={isSalesforceCaseEscalationEnabled}
              isZendeskTicketEscalationEnabled={isZendeskTicketEscalationEnabled}
              isFreshdeskTicketEscalationEnabled={isFreshdeskTicketEscalationEnabled}
              isIntercomCreateConversationEnabled={isIntercomCreateConversationEnabled}
              trashed={trashed}
              topicId={topicId}
              contentType={contentType}
              isReply={false}
            />
            <div className='post--options-list-container'>
              {contentTypeConfig.vote &&
                <Vote
                  topicId={topicId}
                  contentType={contentType}
                  userId={userId}
                  votedBy={votedBy}
                  votes={votes}
                  onChangeVote={onChangeVote}
                />}
              {contentTypeConfig.like &&
                <Like
                  topicId={topicId}
                  contentType={contentType}
                  userId={userId}
                  likedBy={likedBy}
                  likes={likes}
                  onChangeLike={onChangeLike}
                />}
              <Quote data-qa='quote-topic' content={content} author={author} />
              {moderationConfig.subscribe &&
                <SubscribeTopic
                  publicId={publicId}
                  onShowAlert={onShowAlert}
                />}
            </div>
          </footer>
        )
      }}
    </ConfigContext.Consumer>
  )
}

export default OpeningPostContentActions
